import { Field, useFormikContext } from 'formik';
import { t } from 'i18next';
import React from 'react';
import { Card, Col, Form, InputGroup, Row, Button } from 'react-bootstrap';
import { IoReloadCircleSharp } from 'react-icons/io5';
import { useSelector } from 'react-redux';


const vitals = [
	{ name: 'height', label: 'VISIT.VITALS.HEIGHT', unit: 'VISIT.ADD.CM' },
	{ name: 'weight', label: 'VISIT.VITALS.WEIGHT', unit: 'VISIT.ADD.KG' },
	{ name: 'pulse', label: 'VISIT.VITALS.PULSE', unit: 'VISIT.ADD.BPM' },
	{ name: 'bp', label: 'VISIT.VITALS.BP', unit: 'VISIT.ADD.MM_HG' },
	{ name: 'temperature', label: 'VISIT.VITALS.TEMPERATURE', unit: 'VISIT.ADD.F' },
	{ name: 'spo2', label: 'VISIT.VITALS.SPO2', unit: '%' },
];

const VitalsFields = () => {
	const group1 = vitals.slice(0, 3);
	const group2 = vitals.slice(3);
	const { todaysVisits, pastVisits } = useSelector(state => state.visits);
	const { setFieldValue, errors, setFieldError, setFieldTouched } = useFormikContext();

	const getVitalValue = () => {
		const allVisits = [...todaysVisits, ...pastVisits];
		const lastVisit = allVisits[allVisits.length - 1];
		if (lastVisit) {
			const { height, weight, pulse, bp, temperature, spo2 } = lastVisit;
			setFieldValue('vitals.height', Number(height || 0));
			setFieldValue('vitals.weight', Number(weight || 0));
			setFieldValue('vitals.pulse', Number(pulse || 0));
			setFieldValue('vitals.bp', Number(bp || 0));
			setFieldValue('vitals.temperature', Number(temperature || 0));
			setFieldValue('vitals.spo2', Number(spo2 || 0));
			if (errors.vitals) {
				setFieldError('vitals', undefined);
				setFieldTouched('vitals', false);
			}
		}
	};

	const renderRow = (group) => (
		<Row className="my-1 gap-5">
			{group.map(({ name, label, unit }) => (
				<Col md={2} key={name}>
					<Form.Label>{t(label)}</Form.Label>
					<Field name={`vitals.${name}`} className="form-control">
						{({ field, meta }) => (
							<>
								<InputGroup className="mb-1">
									<Form.Control
										{...field}
										isInvalid={meta.touched && !!meta.error}
									/>
									<InputGroup.Text>
										{unit.includes('VISIT.') ? t(unit) : unit}
									</InputGroup.Text>
									<Form.Control.Feedback type="invalid">
										{meta.error}
									</Form.Control.Feedback>
								</InputGroup>
							</>
						)}
					</Field>
				</Col>
			))}
		</Row>
	);

	return (
		<Row>
			<Card.Title>{t('VISIT.VITALS.TITLE')}
				<Button variant="link" onClick={getVitalValue}><IoReloadCircleSharp /></Button></Card.Title>
			{renderRow(group1)}
			{renderRow(group2)}
		</Row>
	);
};

export default VitalsFields;
